import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceLayout } from "../features/context";

export const Route = createFileRoute("/_app/w/$workspace")({ component: WorkspaceLayout });
